<template>
  <div class="sub-heading d-flex align-items-center">
    <i :class="iconClass"></i><span class="ml-2">{{ heading }}</span>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'InitiativeSubHeading',
  props: ['iconClass', 'heading']
}
</script>

<style lang="scss" scoped>
.sub-heading {
  font-weight: 600;
  margin-bottom: 10px;
  line-height: 1.2;
}
</style>
